'use strict';

angular.module('amexReconciliationApp')
  .component('taxDetails', {
    templateUrl: 'scripts/views/components/tax-details.html',
    bindings: {
      billedCurrency: '<',
      transactionTaxes: '=',
      isDisabled: '<'
    },
    controller: function (UserModel) {
      var self = this;
      
      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      self.showTaxDetails = function() {
        return !!self.transactionTaxes && self.transactionTaxes.length;
      };

      self.showActualTaxes = _.get(self.transactionTaxes, '[0].taxAmount') !== 0;
      self.showEstimatedTaxes = _.get(self.transactionTaxes, '[0].taxAmount') === 0;
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/taxDetails.js
// module id = 482
// module chunks = 0